
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_32007_149845)"}},[_c('path',{attrs:{"d":"M18 9.5c0 3.59-3.58 6.5-8 6.5-1.158 0-2.258-.2-3.252-.56a9.254 9.254 0 01-1.697.957C4.3 16.722 3.398 17 2.5 17a.5.5 0 01-.356-.853l.009-.01a3.74 3.74 0 00.194-.222c.128-.156.3-.387.475-.674.312-.52.61-1.2.669-1.966C2.554 12.212 2 10.909 2 9.5 2 5.91 5.582 3 10 3c4.419 0 8 2.91 8 6.5z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_32007_149845"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 2)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    